import { IconInterface } from '../interfaces/icon.interface';

const CarrierCompanyTruck = (props: IconInterface) => {
	const {
		color = '#8B8B8B',
		width = 20,
		height = 20,
		strokeWidth = '1.6',
	} = props;

	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M3 16.5h1.2M3 6h11v10.5H8.8M15.6 16.5h-1.6V9h3.6l2.4 3.4v4.1h-1.2"
				stroke={color}
				strokeWidth={strokeWidth}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<circle
				cx="6.9"
				cy="17.4"
				r="1.9"
				stroke={color}
				strokeWidth={strokeWidth}
			/>
			<circle
				cx="17.4"
				cy="17.4"
				r="1.9"
				stroke={color}
				strokeWidth={strokeWidth}
			/>
		</svg>
	);
};

export default CarrierCompanyTruck;
